import AppBar from "components/AppBar/AppBar";
import LanguageMenu from "components/LanguageMenu/LanguageMenu";

function PageWrap(props) {
  // Note: dispatch is not always given as prop so might be undefined
  const { page, children, t, dispatch } = props;

  return (
    <div className="page-wrap">
      <div className="page-head">
        <h1>{t("app_title")}</h1>
        <div className="larger-than-mobile">
          <div className="page-head-controls">
            <LanguageMenu />
          </div>
        </div>
      </div>
      <div className="page-nav">
        <AppBar currentPageKey={page} t={t} dispatch={dispatch} />
      </div>
      <main className="page-content">{children}</main>
    </div>
  );
}

export default PageWrap;
